export const ServiceProviderUserListColumnsModel = [
  {
    label: 'Name',
    property: 'name',
    type: 'string'
  },
  {
    label: 'Email',
    property: 'email',
    type: 'string'
  },
  {
    label: 'SP Number',
    template: {
      type: 'content',
      property: 'serviceProviderNumbersAsHtml'
    },
    width: 50,
    type: 'html'
  },
  {
    label: 'SP Name',
    template: {
      type: 'content',
      property: 'serviceProviderNamesAsHtml'
    },
    width: 50,
    type: 'html'
  },
  {
    label: 'Groups',
    template: {
      type: 'content',
      property: 'groupsAsHtml'
    },
    width: 50,
    type: 'html'
  }
];
